import { _url, timeout } from "../configs/url";
import { customFetch } from "../configs/refreshToken";
import { STORAGE_KEYS } from "../common/constants/Storage";
import { getStorage } from "../common/constants/Services";

export async function getBlogs(page) {
    let url = _url.server + _url.apiListBlog + "?p=" + page;

    let header = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };
    return timeout(fetch(url, {
        method: 'GET',
        headers: header,
    }).then(res => res.json()));

}

export async function create(data) {
    let url = _url.server + _url.apiCreateBlog;
    let dataResponse = customFetch(url, data, 'POST', '');
    return dataResponse;
}

export async function getAllImage() {
    let url = _url.server + _url.apiGetAllImage;
    let dataResponse = customFetch(url, '', 'GET');
    return dataResponse;
}

export async function uploadImage(file) {
    let token = getStorage(STORAGE_KEYS.ACCESS_TOKEN);
    let url = _url.server + _url.apiUploadImage;
    const formData = new FormData();
    formData.append('file', file);

    let header = {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
    };

    return timeout(fetch(url, {
        method: 'POST',
        headers: header,
        body: formData
    }).then(res => res.json()));
}

export async function removePost(id) {
    let url = _url.server + _url.apiDeleteBlog + '/' + id;
    let dataResponse = customFetch(url, {}, 'DELETE', '');
    return dataResponse;
}

export async function getCategories() {
    let url = _url.server + _url.apiGetBlogCat;
    let header = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };
    return timeout(fetch(url, {
        method: 'GET',
        headers: header,
    }).then(res => res.json()));
}